import {
  ArrowLeft,
  Edit2,
  Save,
  X,
  Trash2,
  Bell,
} from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Badge } from "../ui/badge";

export const TransactionHeader = ({
  transaction,
  isAdmin,
  isEditing,
  setIsEditing,
  editingAddress,
  setEditingAddress,
  addressValue,
  setAddressValue,
  onSaveAddress,
  onUpdate,
  onNotifyParties,
  onShowDelete,
  onBack,
}) => (
  <div className="page-header -mx-6 md:-mx-8 -mt-6 md:-mt-8 mb-6 px-6 md:px-8 py-6">
    <div className="flex items-center gap-4 mb-4">
      <Button variant="ghost" size="sm" onClick={onBack} data-testid="back-btn">
        <ArrowLeft className="w-4 h-4 mr-2" />
        Back
      </Button>
    </div>
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
      <div>
        <div className="flex items-center gap-3">
          {editingAddress ? (
            <div className="flex items-center gap-2">
              <Input
                value={addressValue}
                onChange={(e) => setAddressValue(e.target.value)}
                className="text-xl font-bold h-10 min-w-[300px]"
                autoFocus
                onKeyDown={(e) => { if (e.key === "Enter") onSaveAddress(); if (e.key === "Escape") setEditingAddress(false); }}
                data-testid="edit-address-input"
              />
              <Button size="sm" className="btn-primary h-8" onClick={onSaveAddress} data-testid="save-address-btn">
                <Save className="w-3.5 h-3.5" />
              </Button>
              <Button size="sm" variant="ghost" className="h-8" onClick={() => setEditingAddress(false)} data-testid="cancel-address-btn">
                <X className="w-3.5 h-3.5" />
              </Button>
            </div>
          ) : (
            <>
              <h1 className="text-2xl sm:text-3xl font-bold text-[var(--t-text)] [font-family:var(--t-heading-font)] tracking-tight">
                {transaction.property_address}
              </h1>
              <button
                onClick={() => { setAddressValue(transaction.property_address || ""); setEditingAddress(true); }}
                className="text-[var(--t-text-subtle)] hover:text-[var(--t-primary)] transition-colors p-1 rounded hover:bg-[var(--t-bg)]"
                title="Edit address"
                data-testid="edit-address-btn"
              >
                <Edit2 className="w-4 h-4" />
              </button>
            </>
          )}
          <Badge className={`status-badge ${transaction.status}`}>
            {transaction.status === 'active_listing' ? 'Active Listing' : transaction.status === 'active' ? 'Before Inspections' : (transaction.status === 'through_inspections' || transaction.status === 'pending') ? 'Through Inspections' : transaction.status}
          </Badge>
        </div>
        <div className="flex flex-wrap items-center gap-3 mt-2 text-sm text-[var(--t-text-muted)]">
          <span className="capitalize">{transaction.property_type.replace('_', ' ')}</span>
          <span>•</span>
          <span className="capitalize">Our Rep: {transaction.transaction_side} Side</span>
        </div>
      </div>
      <div className="flex gap-2">
        {isEditing ? (
          <>
            <Button variant="outline" onClick={() => setIsEditing(false)} data-testid="cancel-edit-btn">
              <X className="w-4 h-4 mr-2" />
              Cancel
            </Button>
            <Button className="btn-primary" onClick={onUpdate} data-testid="save-edit-btn">
              <Save className="w-4 h-4 mr-2" />
              Save
            </Button>
          </>
        ) : (
          <>
            <Button variant="outline" onClick={onNotifyParties} className="text-[var(--t-primary)] border-[var(--t-primary)]/30 hover:bg-[var(--t-primary)]/5" data-testid="notify-parties-btn">
              <Bell className="w-4 h-4 mr-2" />
              Notify Parties
            </Button>
            <Button variant="outline" onClick={() => setIsEditing(true)} data-testid="edit-btn">
              <Edit2 className="w-4 h-4 mr-2" />
              Edit
            </Button>
            {isAdmin && (
              <Button
                variant="outline"
                className="text-red-600 hover:text-red-700 hover:bg-red-50"
                onClick={onShowDelete}
                data-testid="delete-btn"
              >
                <Trash2 className="w-4 h-4" />
              </Button>
            )}
          </>
        )}
      </div>
    </div>
  </div>
);
